const routes = [
    {
        path: "/housing/rooms",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "housingroom_index"
        }
    }
]

export default routes;
